/**
 * Alurea homepage — small dependency-free helpers.
 * - Reviews carousel arrows (delegated, safe for multiple instances)
 * - Quantity selector +/- buttons
 * - Variant select: price + availability updates
 * - Optional reveal-on-scroll animation
 * All listeners are attached once at document level, so Theme Editor
 * section reloads never duplicate handlers.
 */
(function () {
  'use strict';

  if (window.AlureaHome) return; // idempotent across editor reloads
  window.AlureaHome = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Carousel arrows -------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-alurea-scroll]');
    if (arrow) {
      var section = arrow.closest('.alurea-section');
      var track = section && section.querySelector('[data-alurea-track]');
      if (track) {
        var card = track.querySelector(':scope > *');
        var step = card ? card.getBoundingClientRect().width + 16 : 340;
        var dir = arrow.getAttribute('data-alurea-scroll') === 'prev' ? -1 : 1;
        track.scrollBy({ left: dir * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
      return;
    }

    var qtyBtn = e.target.closest('[data-alurea-qty]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('.alurea-qty');
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        val += qtyBtn.getAttribute('data-alurea-qty') === 'minus' ? -1 : 1;
        input.value = Math.max(1, val);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  /* Variant select --------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-alurea-variant-select]');
    if (!select) return;
    var section = select.closest('.alurea-section');
    if (!section) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var priceEl = section.querySelector('[data-alurea-price]');
    var compareEl = section.querySelector('[data-alurea-compare]');
    var badgeEl = section.querySelector('[data-alurea-sale-badge]');
    var button = section.querySelector('[data-alurea-atc]');
    var idInput = section.querySelector('form [name="id"]');

    if (idInput) idInput.value = option.value;
    if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

    var hasCompare = option.dataset.compare && option.dataset.compare !== '';
    if (compareEl) {
      compareEl.hidden = !hasCompare;
      if (hasCompare) compareEl.textContent = option.dataset.compare;
    }
    if (badgeEl) badgeEl.hidden = !hasCompare;

    if (button) {
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      var label = button.querySelector('[data-alurea-atc-label]');
      if (label) {
        label.textContent = available
          ? button.getAttribute('data-alurea-atc-text')
          : button.getAttribute('data-alurea-soldout-text');
      }
    }
  });

  /* Reveal on scroll (only when a section opts in) -------------------- */
  var observer = null;
  function observeReveals(root) {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      (root || document).querySelectorAll('.alurea-animate [data-alurea-reveal]').forEach(function (el) {
        el.classList.add('alurea-revealed');
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('alurea-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    (root || document).querySelectorAll('.alurea-animate [data-alurea-reveal]:not(.alurea-revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeReveals(document); });
  } else {
    observeReveals(document);
  }

  /* Theme Editor: re-observe after a section is (re)loaded ------------ */
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
  });
})();
